const systemColumns = [
  "selection",
  "expander",
  "fileextensionicon",
  "favourite",
  "strictlyconfidential",
];

export default systemColumns;
